import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";

const ITEMS_PER_PAGE = 10;

const formatValue = (value) => {
  if (value === "True" || value === true) return "Sí";
  if (value === "False" || value === false) return "No";
  return value;
};

// Elimina la parte de hora (ej. " 00:00") de valores de fecha en campos de tipo fecha
const formatDateValue = (value, campo) => {
  if (!value || typeof value !== "string") return formatValue(value);
  // Detectar si el campo es de tipo fecha por su nombre
  const campoLower = (campo || "").toLowerCase();
  const esCampoFecha = campoLower.includes("fec.") || campoLower.includes("fec ") ||
    campoLower.includes("fecha") || campoLower.startsWith("fec");
  if (esCampoFecha) {
    // Excepción: "fecha subsanada" debe mostrar la hora
    if (campoLower.includes("subsanada")) {
      return formatValue(value);
    }
    // Eliminar la parte de hora " HH:mm" o " HH:mm:ss" al final
    return value.replace(/\s+\d{2}:\d{2}(:\d{2})?$/, "");
  }
  return formatValue(value);
};

export const ModuleAuditoriaCampos = ({
  data = [],
  metadata,
  ocultar,
  access
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / ITEMS_PER_PAGE));

  // Resetear página si los datos cambian y la página actual queda fuera de rango
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [data.length, totalPages, currentPage]);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedData = data.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <S.Wrapper>
      <S.Header>
        <span>Notificaciones de Campos</span>
      </S.Header>
      <S.Content>
      <table>
          <thead>
            <S.TrColumnTitles>
              {metadata.map((e) => (
                <th key={e.name}>{e.label}</th>
              ))}
            </S.TrColumnTitles>
          </thead>
          <tbody>
            {paginatedData.map((register, i) => (
              <tr key={startIndex + i}>
                {metadata.map((field) => (
                  <td key={field.name}>
                    {(field.name === "valorAnterior" || field.name === "valorNuevo")
                      ? formatDateValue(register[field.name], register.campo)
                      : formatValue(register[field.name])}
                    {field.name === "ocultar" && (
                      <FontAwesomeIcon
                        icon={faEye}
                        onClick={()=>ocultar(register.idNotificacion,true,false)}
                        disabled={!access?.Editar}
                        size="lg"
                      />
                    )}
                    {field.name === "eliminar" && (
                      <FontAwesomeIcon
                        icon={faTrash}
                        onClick={()=>ocultar(register.idNotificacion,false,true)}
                        disabled={!access?.Editar}
                        size="lg"
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
            {data.length === 0 && (
              <tr>
                <td>No hay registros</td>
              </tr>
            )}
          </tbody>
        </table>
        {data.length > ITEMS_PER_PAGE && (
          <S.Pagination>
            <button
              type="button"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(1)}
            >
              &laquo;
            </button>
            <button
              type="button"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              &lsaquo;
            </button>
            <span>
              Página {currentPage} de {totalPages}
            </span>
            <button
              type="button"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              &rsaquo;
            </button>
            <button
              type="button"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
            >
              &raquo;
            </button>
          </S.Pagination>
        )}
      </S.Content>
    </S.Wrapper>
  );
};

ModuleAuditoriaCampos.propTypes = {
  data: PropTypes.array,
  metadata: PropTypes.array,
  ocutar:PropTypes.func,
  access:PropTypes.object
};
